import React from 'react';
import { Navigate } from 'react-router-dom';

// Password setup is now handled by Clerk.
// This screen redirects to login for backwards compatibility with old email links.
export default function SetupPasswordScreen() {
  return <Navigate to="/login" replace />;
}
